export default "__VITE_ASSET__CpgRDG_f__"